import { useEffect } from "react";
import { Switch, Route, useLocation } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ErrorBoundary } from "@/components/error-boundary";
import { initPostHog } from "@/lib/posthog";
import { WhatsNewModal } from "@/components/whats-new-modal";
import { useWhatsNew } from "@/hooks/use-whats-new";
import NotFound from "@/pages/not-found";
import Home from "@/pages/home";
import Pricing from "@/pages/pricing";
import LibraryPage from "@/pages/library";
import AdminPage from "@/pages/admin";
import CheckoutSuccess from "@/pages/checkout-success";
import TermsPage from "@/pages/terms";
import PrivacyPage from "@/pages/privacy";
import SharedVideoPage from "@/pages/shared-video";
import ComparePage from "@/pages/compare";
import AudioPage from "@/pages/audio";

// Apply saved theme before first paint to prevent flash
const _t = localStorage.getItem("dance-mirror-theme");
if (_t === "dark" || (!_t && window.matchMedia("(prefers-color-scheme: dark)").matches)) {
  document.documentElement.classList.add("dark");
}

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/pricing" component={Pricing} />
      <Route path="/library" component={LibraryPage} />
      <Route path="/admin" component={AdminPage} />
      <Route path="/checkout/success" component={CheckoutSuccess} />
      <Route path="/terms" component={TermsPage} />
      <Route path="/privacy" component={PrivacyPage} />
      <Route path="/shared/:token" component={SharedVideoPage} />
      <Route path="/compare" component={ComparePage} />
      <Route path="/audio" component={AudioPage} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  useEffect(() => {
    initPostHog();
  }, []);

  const { open, dismiss } = useWhatsNew();
  const [location] = useLocation();
  const isSharedVideo = location.startsWith("/shared/");

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <WhatsNewModal open={open && !isSharedVideo} onDismiss={dismiss} />
          <Toaster />
          <Router />
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
